import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  Grid,
  Paper,
  Stack,
  TextField,
  Button,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
} from "@mui/material";
import instance from "../utils/axiosInstance";
import { useNavigate } from "react-router-dom";

import { ethers } from "ethers"; 
import { getMetaFromTokenURI } from "../utils/meta_in_token"; 

const Wallet = ({ user, setUser }) => {
  const [wallets, setWallets] = useState([]);
  const [createPassword, setCreatePassword] = useState("");
  const [jsonPassword, setJsonPassword] = useState("");
  const [keystoreFile, setKeystoreFile] = useState(null);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogType, setDialogType] = useState(null);
  const [dialogAddress, setDialogAddress] = useState("");
  const [dialogPassword, setDialogPassword] = useState("");
  const [creating, setCreating] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    instance.get("/user/me", { withCredentials: true })
      .then((res) => {
        setUser(res.data.user);
        fetchWallets();
      })
      .catch(() => {
        setUser(null);
        navigate("/login");
      });
  }, [navigate]);

  const fetchWallets = async () => {
    try {
      const res = await instance.get("/wallet/me", { withCredentials: true });
      setWallets(res.data.wallets);
      setError("");
    } catch (error) {
      console.error("지갑 목록 불러오기 실패:", error);
      setError("지갑 목록을 불러오지 못했습니다.");
    }
  };

  const handleCreateWallet = async () => {
    if (!createPassword) return setError("비밀번호를 입력하세요.");
    setCreating(true);
    setMessage("");
    setError("");
    try {
      const res = await instance.post("/wallet/create", { password: createPassword }, { withCredentials: true });
      setMessage("지갑 생성 및 ETH 전송 완료!");
      setCreatePassword("");
      fetchWallets();
    } catch (error) {
      console.error("지갑 생성 오류:", error);
      setError(error.response?.data?.message || "지갑 생성 실패");
    } finally {
      setCreating(false);
    }
  };

  const fetchAndSendMetadata = async (nft) => {
    try {
      const meta = await getMetaFromTokenURI(nft.tokenURI);
      console.log("fetch 진입입");
  
      if (!meta) {
        console.warn("❌ 메타데이터 파싱 실패:", nft.tokenURI);
        return;
      }
      await instance.post("/nftmanage/updateMeta", {
        metaDatas: [
          {
            nftId: nft.nftId,
            tokenName: meta.name || "",
            tokenDescription: meta.description || "",
          }
        ]
      }, { withCredentials: true });
  
      console.log("✅ 메타데이터 저장 성공:", nft.tokenId, meta.name);
  
    } catch (err) {
      console.warn("🔥 메타데이터 fetch 실패:", err.message);
    }
  };
  
  
  

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (event) => {
      try {
        const json = JSON.parse(event.target.result);
        setKeystoreFile(JSON.stringify(json));
      } catch {
        setError("올바른 JSON 파일을 업로드하세요.");
      }
    };
    reader.readAsText(file);
  };

  const handleImportJson = async () => {
    if (!keystoreFile || !jsonPassword) {
      setError("Keystore JSON 및 비밀번호를 입력하세요.");
      return;
    }
  
    try {
      // 1. 지갑 추가
      const res = await instance.post("/wallet/connect", {
        keystoreJson: keystoreFile,
        password: jsonPassword
      }, { withCredentials: true });
  
      setMessage("지갑 추가 완료!");
      const nftList = res.data.nftList;
      console.log("지갑에 등록된 NFT 목록:", nftList);
  
      if (nftList && nftList.length > 0) {
        console.log("🔍 메타데이터 수집 시작...");
        const metaDatas = [];
  
        for (const nft of nftList) {
          try {
            const meta = await getMetaFromTokenURI(nft.tokenURI);
            if (!meta) {
              console.warn("❌ 메타데이터 없음:", nft.tokenURI);
              continue;
            }
            console.log(meta);
            metaDatas.push({
              nftId: nft.nftId,
              tokenName: meta.name || "",
              tokenDescription: meta.description || "",
              creator: meta.creator || "",
            });
  
          } catch (err) {
            console.warn("🔥 메타데이터 파싱 실패:", nft.tokenId, err.message);
          }
        }
  
        // 2. 한 번에 메타데이터 업데이트 요청
        if (metaDatas.length > 0) {
          console.log("📡 메타데이터 전송 시작...", metaDatas);
          const updateRes = await instance.post("/nftmanage/updateMeta", {
            metaDatas
          }, { withCredentials: true });
  
          console.log("✅ 메타데이터 저장 결과:", updateRes.data);
        }
      }
  
      setKeystoreFile(null);
      setJsonPassword("");
      fetchWallets(); // 지갑 목록 갱신
    } catch (error) {
      console.error("지갑 추가 오류:", error);
      setError(error.response?.data?.message || "지갑 추가 실패");
    }
  };
  

  const handleDialogOpen = (type, address) => {
    setDialogType(type);
    setDialogAddress(address);
    setDialogPassword("");
    setDialogOpen(true);
  };

  const handleDialogConfirm = async () => {
    setDialogOpen(false);
    if (!dialogPassword) return setError("비밀번호를 입력하세요.");

    if (dialogType === "export") {
      try {
        const res = await instance.post(
          `/wallet/export/${dialogAddress}`,
          { password: dialogPassword },
          { withCredentials: true, responseType: "blob" }
        );
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `keystore_${dialogAddress}.json`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        setMessage("JSON 파일 다운로드 완료!");
      } catch (error) {
        console.error("JSON 내보내기 오류:", error);
        setError(error.response?.data?.message || "JSON 내보내기 실패");
      }
    } else if (dialogType === "delete") {
      try {
        await instance.delete(`/wallet/delete/${dialogAddress}`, {
          data: { password: dialogPassword },
          withCredentials: true,
        });
        setMessage("지갑 삭제 완료!");
        fetchWallets();
      } catch (error) {
        console.error("지갑 삭제 오류:", error);
        setError(error.response?.data?.message || "지갑 삭제 실패");
      }
    }
  };

  return (
    <Container sx={{ mt: 6, mb: 10 }}>
      <Typography variant="h4" fontWeight="bold" gutterBottom color="text.primary">
        지갑 관리
      </Typography>

      <Grid container spacing={4}>
        {/* 왼쪽 - 지갑 목록 */}
        <Grid item xs={12} md={8}>
          <Paper elevation={3} sx={{ p: 4, borderRadius: 3, bgcolor: "background.paper" }}>
            <Typography variant="h6" gutterBottom>내 지갑 목록</Typography>

            {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
            {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

            <Stack spacing={2}>
              {wallets.length > 0 ? (
                wallets.map((wallet, index) => (
                  <Grid container spacing={2} key={index} alignItems="center">
                    <Grid item xs={12} sm={8}>
                      <Typography>주소 : {wallet.address}</Typography>
                      <Typography>잔액 : {wallet.balance || "조회 불가"}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Stack direction="row" spacing={1} justifyContent="flex-end">
                        <Button
                          variant="outlined"
                          color="primary"
                          fullWidth
                          onClick={() => handleDialogOpen("export", wallet.address)}
                        >
                          JSON<br />내보내기
                        </Button>
                        <Button
                          variant="outlined"
                          color="error"
                          fullWidth
                          onClick={() => handleDialogOpen("delete", wallet.address)}
                        >
                          삭제
                        </Button>
                      </Stack>
                    </Grid>
                  </Grid>
                ))
              ) : (
                <Typography color="text.secondary">지갑이 없습니다.</Typography>
              )}
            </Stack>
          </Paper>
        </Grid>

        {/* 오른쪽 - 새 지갑 생성 & 가져오기 */}
        <Grid item xs={12} md={4}>
          <Stack spacing={4}>
            {/* 새 지갑 생성 */}
            <Paper elevation={3} sx={{ p: 4, borderRadius: 3, bgcolor: "background.paper" }}>
              <Typography variant="h6" gutterBottom>새 지갑 생성</Typography>
              <Stack spacing={2}>
                <TextField
                  label="비밀번호 입력"
                  type="password"
                  fullWidth
                  value={createPassword}
                  onChange={(e) => setCreatePassword(e.target.value)}
                  disabled={creating}
                />

                <Button
                  variant="contained"
                  fullWidth
                  onClick={handleCreateWallet}
                  disabled={creating}
                >
                  {creating ? "지갑 생성 중..." : "지갑 생성"}
                </Button>

                {creating && (
                  <Stack direction="row" spacing={1} alignItems="center" justifyContent="center">
                    <Typography color="text.secondary">ETH 전송 중입니다...</Typography>
                    <CircularProgress size={20} />
                  </Stack>
                )}
              </Stack>

            </Paper>

            {/* Keystore 가져오기 */}
            <Paper elevation={3} sx={{ p: 4, borderRadius: 3, bgcolor: "background.paper" }}>
              <Typography variant="h6" gutterBottom>Keystore JSON 추가</Typography>
              <Stack spacing={2}>



                {keystoreFile ? (
                  <Button variant="outlined" component="label" fullWidth>
                    파일이 선택되었습니다
                  <input type="file" hidden accept=".json" onChange={handleFileChange} />
                  </Button>
                ): (
                <Button variant="outlined" component="label" fullWidth>
                  파일 선택
                  <input type="file" hidden accept=".json" onChange={handleFileChange} />
                </Button>
              )}
                <TextField
                  label="비밀번호 입력"
                  type="password"
                  fullWidth
                  value={jsonPassword}
                  onChange={(e) => setJsonPassword(e.target.value)}
                />
                <Button variant="contained" fullWidth onClick={handleImportJson}>
                  지갑 추가
                </Button>
              </Stack>
            </Paper>
          </Stack>
        </Grid>
      </Grid>

      {/* 비밀번호 입력 다이얼로그 */}
      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle>비밀번호 입력</DialogTitle>
        <DialogContent>
          <TextField
            label="비밀번호"
            type="password"
            fullWidth
            value={dialogPassword}
            onChange={(e) => setDialogPassword(e.target.value)}
            sx={{ mt: 2 }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)}>취소</Button>
          <Button variant="contained" onClick={handleDialogConfirm}>
            확인
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default Wallet;
